// Phase nav/shell — /read tab. ReadTab (the full story shelf) already
// exists as a screen; this routes it so the bottom tab bar's "Read" tab
// has a destination. Mirrors pal.tsx.
import { createFileRoute } from "@tanstack/react-router";
import { ReadTab } from "@/screens/ReadTab";

export const Route = createFileRoute("/read")({
  component: ReadTab,
});
